class VoiceService {
    constructor() {
        this.recognition = null;
        this.isSupported = 'webkitSpeechRecognition' in window || 'SpeechRecognition' in window;
        
        if (this.isSupported) {
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            this.recognition = new SpeechRecognition();
            this.recognition.continuous = false;
            this.recognition.interimResults = true;
        }
    }

    startListening(onResult, onEnd, onError) {
        if (!this.isSupported) {
            onError('Speech recognition is not supported in this browser');
            return;
        }

        this.recognition.onresult = (event) => {
            const transcript = Array.from(event.results)
                .map(result => result[0].transcript)
                .join('');
            
            onResult(transcript);
        };

        this.recognition.onend = () => {
            onEnd();
        };

        this.recognition.onerror = (event) => {
            onError(event.error);
        };

        this.recognition.start();
    }

    stopListening() {
        if (this.recognition) {
            this.recognition.stop();
        }
    }

    isVoiceSupported() {
        return this.isSupported;
    }
}

export default VoiceService;
